import React from "react";
import { UrlModalType, WaitlistFeature } from "@/constants/urlModal";
import { WaitlistModal } from "./WaitlistModal";
import { UnknownModal } from "./UnknownModal";

export interface UrlModalStrategyProps {
    isOpen: boolean;
    onClose: () => void;
    resource: string | null;
}

const modalRegistry: Record<UrlModalType, React.FC<UrlModalStrategyProps>> = {
    [UrlModalType.Waitlist]: WaitlistModal
};

const allowResourceForType: Record<UrlModalType, (value: string) => boolean> = {
    [UrlModalType.Waitlist]: (value: string) =>
        [WaitlistFeature.ContinuousImprovement].includes(value)
};

interface UrlModalProps {
    isOpen: boolean;
    onClose: () => void;
    modalType: string | null;
    resource: string | null;
}

export const UrlModal: React.FC<UrlModalProps> = ({ isOpen, onClose, modalType, resource }) => {
    if (!isOpen || !modalType) {
        return null;
    }

    const isKnownType = Object.values(UrlModalType).includes(modalType as UrlModalType);

    if (!isKnownType) {
        return <UnknownModal isOpen={isOpen} onClose={onClose} modalType={modalType} />;
    }

    const isAllowedResource = allowResourceForType[modalType as UrlModalType](resource);

    if (!isAllowedResource) {
        return <UnknownModal isOpen={isOpen} onClose={onClose} modalType={modalType} />;
    }

    const ModalComponent = modalRegistry[modalType as UrlModalType];

    return <ModalComponent isOpen={isOpen} onClose={onClose} resource={resource} />;
};
